import Vue from 'vue'
import Router from 'vue-router'

// Components
import Home from './../components/Home/index.vue'
import Ref from './../components/Ref.vue'
import Register from './../components/Register/index.vue'
import Login from './../components/Login/index.vue'
import ResetPassword from './../components/ResetPassword/index.vue'
import Dashboard from './../components/Dashboard/index.vue'
import Profile from './../components/Profile/index.vue'
import Cnpros from './../components/Cnpros/index.vue'
import Cnpro from './../components/Cnpro/index.vue'
import CnproSearch from './../components/CnproSearch/index.vue'
import Businesses from './../components/Businesses/index.vue'
import Business from './../components/Business/index.vue'
import BusinessSearch from './../components/BusinessSearch/index.vue'
import CnproAccounts from './../components/CnproAccounts/index.vue'
import BusinessListings from './../components/BusinessListings/index.vue'
import Contracts from './../components/Contracts/index.vue'
import SavedListings from './../components/SavedListings/index.vue'
import Forums from './../components/Forums/index.vue'
import Forum from './../components/Forum/index.vue'
import Cnsurveys from './../components/Cnsurveys/index.vue'
import Cnsurvey from './../components/Cnsurvey/index.vue'
import CnsurveyRequests from './../components/CnsurveyRequests/index.vue'
import Pricing from './../components/Pricing/index.vue'
import Terms from './../components/Terms/index.vue'
import Policy from './../components/Policy/index.vue'
import About from './../components/About/index.vue'
import HowItWorks from './../components/HowItWorks/index.vue'
import MyMoney from './../components/MyMoney/index.vue'
import FindCnpro from './../components/FindCnpro/index.vue'
//import CNpay from './../components/CNpay/index.vue'
import CNwallet from './../components/CNwallet/index.vue'
import MyReferrals from './../components/MyReferrals/index.vue'
import CNpayTransactions from './../components/CNpayTransactions/index.vue'
import CNdiscountSystem from './../components/CNdiscountSystem/Template/index.vue'
import CNdiscounts from './../components/CNdiscountSystem/CNdiscounts/index.vue'
import CNdiscountPost from './../components/CNdiscountSystem/CNdiscountPost/index.vue'
import CNdiscountSetup from './../components/CNdiscountSetup/index.vue'
import CNInsuranceSystem from './../components/CNInsuranceSystem/Template/index.vue'
import CNInsurance from './../components/CNInsuranceSystem/CNInsurance/index.vue'
import CNInsuranceListing from './../components/CNInsuranceSystem/CNInsuranceListing/index.vue'
//new for some account routes
import Account from './../components/Account/Template/index.vue'
import CNinsuranceAccount from './../components/Account/CNinsurance/index.vue'
import PricingPayments from './../components/PricingPayments/index.vue'
import CNPayments from './../components/CNPayments/index.vue'
import CNProcesses from './../components/CNProcesses/index.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
   
    {path: '/', name: 'Home', component: Home},
   // {path: '/:request/:context_pg', name: 'HomeRR', component: HomeRR, props: true},
    // {path: '/businesses/:request', name: 'HomeRR', component: HomeRR, props: true},
    {path: '/register', name: 'Register', component: Register},
    {path: '/login', name: 'Login', component: Login},
    {path: '/reset', name: 'ResetPassword', component: ResetPassword},
    {path: '/dashboard', name: 'Dashboard', component: Dashboard},
    {
      path: '',
      component: Account,
      children: [
        {
          path: '/account-cninsurance',
          name: 'CNinsuranceAccount',
          component: CNinsuranceAccount,
        },
        {
          path: '/account-cninsurance/:ref',
          name: 'CNinsuranceAccountRef',
          component: CNinsuranceAccount,
        },
        // {
        //   path: '/account/cndiscounts',
        //   name: 'CNinsuranceAccount',
        //   component: CNdiscountsAccount,
        // },
      ]
    },
    {path: '/profile', name: 'Profile', component: Profile},
    {path: '/cnpros', name: 'Cnpros', component: Cnpros, meta:{title: 'CNpros', metaTags: [
      {
        name: 'description',
        content: 'Find Pre-verified Freelance Service Professionals  (CNpros)'
      },
      {
        property: 'og:description',
        content: 'Find Pre-verified Freelance Service Professionals  (CNpros)'
      }
    ]}},
    {path: '/cnpro-search', name: 'CnproSearch', component: CnproSearch},
    {path: '/cnpro', name: 'Cnpro', component: Cnpro},
    {path: '/businesses', name: 'Businesses', component: Businesses,meta:{title: 'Businesses', metaTags: [
      {
        name: 'description',
        content: 'Find Pre-verified Businesses'
      },
      {
        property: 'og:description',
        content: 'Find Pre-verified Businesses'
      }
    ]}},
    {path: '/business', name: 'Business', component: Business},
    {path: '/business-search', name: 'BusinessSearch', component: BusinessSearch},
    {path: '/cnpro-accounts', name: 'CnproAccounts', component: CnproAccounts},
    {path: '/business-listings', name: 'BusinessListings', component: BusinessListings},
    {path: '/contracts', name: 'Contracts', component: Contracts},
    {path: '/saved-listings', name: 'SavedListings', component: SavedListings},
    {path: '/forums', name: 'Forums', component: Forums},
    {path: '/forum', name: 'Forum', component: Forum},
    // {
    //   path: '/forum/:topic', 
    //     name: 'Forum', 
    //     component: Forum,
    //      beforeEnter: (to, from, next) => {
    //         if (routeVal.validation() === false) {
    //             next({ path: '/' })
    //         }else if (routeVal.validation() === true) {
    //             next()
    //         }
    //     }
    // },
    {path: '/cnsurveys', name: 'Cnsurveys', component: Cnsurveys},
    {path: '/cnsurvey', name: 'Cnsurvey', component: Cnsurvey},
    {path: '/survey-requests', name: 'CnsurveyRequests', component: CnsurveyRequests},
    {path: '/pricing', name: 'Pricing Page', component: Pricing},
    {path: '/pricingpayments', name: 'Pricing Payments', component: PricingPayments},
    {path: '/cnpayments', name: 'CNPayments', component: CNPayments},
    {path: '/cnprocesses', name: 'CNProcesses', component: CNProcesses},
    {path: '/terms', name: 'Terms', component: Terms},
    {path: '/policy', name: 'Policy', component: Policy},
    {path: '/about', name: 'About', component: About},
    {path: '/how-it-works', name: 'HowItWorks', component: HowItWorks},
    {path: '/mymoney', name: 'MyMoney', component: MyMoney},
    {path: '/help-me-find-a-cnpro', name: 'FindCnpro', component: FindCnpro},
    // {path: '/cnpay', name: 'CNpay', component: CNpay},
    {path: '/cnwallet', name: 'CNwallet', component: CNwallet},
    {path: '/cnpaytransactions', name: 'CNpayTransactions', component: CNpayTransactions},
    {path: '/myreferrals', name: 'MyReferrals', component: MyReferrals},
    // {path: '/cndiscounts', name: 'CNdiscounts', component: CNdiscounts},
    {path: '/cndiscountsetup', name: 'CNdiscountsetup', component: CNdiscountSetup},
    {path: '/discountbazaarsetup', name: 'DiscountBazaarsetup', component: CNdiscountSetup},
    {
      path: '',
      component: CNdiscountSystem,
      children: [
        {
          path: '/cndiscounts',
          name: 'CNdiscounts',
          component: CNdiscounts,
        },
        {
          path: '/cndiscount'+':cndiscountref',
          name: 'CNdiscountPost',
          component: CNdiscountPost,
        },
        //---new--rename--matain-old-cos-of-if-breakage-effects
        {
          path: '/discountbazaar/',
          name: 'DiscountBazaar',
          component: CNdiscounts,
        },
        
        {
          path: '/discountbazaar'+':cndiscountref',
          name: 'DiscountBazaarPost',
          component: CNdiscountPost,
        },
        // {
        //   // path: '/cndiscounts/:cndiscountref',
        //   path: '/:cndiscountref',
        //   name: 'CNdiscountPost',
        //   component: CNdiscountPost,
        // },
      ]
    },
    //{path: '/cninsurance', name: 'CNInsurance', component: CNInsurance},
    {
      path: '',
      component: CNInsuranceSystem,
      children: [
        {
          path: '/cninsurance',
          name: 'CNInsurance',
          component: CNInsurance,
        },
        {
          path: '/cninsurance'+':cninsurancelisting',
          name: 'CNInsuranceListing',
          component: CNInsuranceListing,
        },
        {
          path: '/insuremoto',
          name: 'InsureMoto',
          component: CNInsurance,
        },
        // {
        //   path: '/insuremoto/',
        //   name: 'InsureMoto',
        //   component: CNInsurance,
        //   pathToRegexpOptions: { strict: true },
        // },
        {
          path: '/insuremoto'+':cninsurancelisting',
          name: 'InsureMotoListing',
          component: CNInsuranceListing,
        },
        // {
        //   // path: '/cninsurance/:listing',
        //   path: '/:cninsurancelisting',
        //   name: 'CNInsuranceListing',
        //   component: CNInsuranceListing,
        // },
        {
          // path: '/cninsurance/:listing/:ref',
          path: '/:cninsurancelisting/:ref',
          name: 'CNInsuranceListingRef',
          component: CNInsuranceListing,
        },
      ]
    },
    {path: '/:refno', component: Ref,
      children: [
      {
        path: '',
        name: 'Ref',
        component: Ref,
      },
     
    ]},

    //--new-with-trailing backlashes---edit diff at sub versions
    {path: '/cnpro/', name: 'Cnpro', component: Cnpro},
    {path: '/businesses/', name: 'Businesses', component: Businesses},
    {path: '/discountbazaar/',name: 'DiscountBazaar',component: CNdiscounts},
    //{path: '/insuremoto/', name: 'InsureMoto',component: CNInsurance, pathToRegexpOptions: { strict: false } },
   // {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js